import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconZoomIn$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconZoomIn extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4d8d17d8f152fd1cb014542edaab8369a2bcccdd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6dc2def47f802547ce4262cd762e0ad1211a9848', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0ea12f5dc50f438f6359778d36256dbaed121d87', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 9a6 6 0 1 1 12 0A6 6 0 0 1 3 9m10.5 0A4.5 4.5 0 0 0 9 4.5 4.51 4.51 0 0 0 4.5 9a4.5 4.5 0 1 0 9 0m-2-.75H9.75V6.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1.75H6.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1.75v1.75a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V9.75h1.75a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5m3.127 6.713a.5.5 0 0 0 0 .707l3.5 3.5a.5.5 0 0 0 .708 0l.353-.354a.5.5 0 0 0 0-.707l-3.5-3.5a.5.5 0 0 0-.707 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-zoom-in", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-zoom-in"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-zoom-in":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconZoomIn$1);
            }
            break;
    } });
}

const CosmosIconZoomIn = CosmosIconZoomIn$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconZoomIn, defineCustomElement };
